var _g, _rect, _g2, _rect2, _g3, _rect3, _g4, _rect4, _g5, _rect5, _g6, _rect6, _g7, _rect7, _path, _circle, _path2, _circle2, _circle3, _circle4, _circle5, _circle6, _rect8, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollectiveSteps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 275,
    height: 148,
    viewBox: "0 0 275 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11304_9686)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.655 123.826C181.232 125.674 196.978 112.923 198.825 95.3466C200.672 77.7703 187.922 62.0243 170.345 60.1769C152.769 58.3296 137.023 71.0804 135.176 88.6567C133.328 106.233 146.079 121.979 163.655 123.826Z",
    fill: "#006FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.537 97.8021L170.316 97.088C169.34 95.11 169.031 92.4127 169.123 89.6587C169.497 83.2825 172.266 78.5398 175.908 78.6266L176.104 78.6471C179.325 78.9857 181.782 83.7841 181.624 89.9856C181.531 92.7395 180.874 95.2367 179.878 97.2046L179.611 97.8675L178.927 97.7956C177.776 97.4773 176.312 97.3234 175.218 97.4057C173.949 97.2724 172.541 97.5192 171.436 97.6992L170.537 97.8021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.619 95.1919L162.983 94.5393C164.35 92.8076 165.212 90.2334 165.695 87.5205C166.655 81.2059 164.933 75.9912 161.352 75.3187L161.254 75.3084C158.032 74.9698 154.632 79.1526 153.497 85.2515C153.015 87.9644 153.138 90.5436 153.704 92.6757L153.827 93.3796L154.413 93.4412C155.605 93.369 157.069 93.5229 158.123 93.831C159.392 93.9644 160.717 94.4986 161.761 94.9043L162.619 95.1919Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.323 108.853C170.59 108.565 169.074 105.149 169.679 101.264C169.71 100.972 169.762 100.484 169.792 100.191L170.07 99.4302L178.727 100.636L178.635 101.515C178.604 101.808 178.553 102.296 178.522 102.589C178.219 106.406 175.862 109.119 173.323 108.853Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.499 105.414C160.232 105.702 162.425 102.675 162.641 98.7498C162.671 98.4569 162.723 97.9688 162.753 97.6759L162.64 96.8745L153.921 96.2541L153.839 97.0351C153.808 97.328 153.757 97.8161 153.726 98.109C153.228 101.906 155.058 105.158 157.499 105.414Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 137.631,
    y: 55.733,
    width: 66,
    height: 66,
    rx: 33,
    transform: "rotate(6 137.631 55.733)",
    stroke: "#E7F1FF",
    strokeWidth: 2
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_11304_9686)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.508 120.869C118.69 119.483 128.253 107.674 126.868 94.4918C125.482 81.3096 113.673 71.7464 100.491 73.1319C87.3084 74.5174 77.7452 86.3269 79.1308 99.5092C80.5163 112.691 92.3257 122.255 105.508 120.869Z",
    fill: "#006FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.498 100.704L106.225 100.215C105.2 98.9163 104.553 96.9856 104.191 94.951C103.471 90.215 104.762 86.304 107.448 85.7996L107.595 85.7842C110.011 85.5302 112.561 88.6673 113.412 93.2415C113.774 95.2762 113.681 97.2106 113.257 98.8097L113.165 99.3376L112.652 99.3914C111.758 99.3374 110.66 99.4528 109.87 99.6839C108.918 99.7839 107.924 100.185 107.142 100.489L106.498 100.704Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.281 100.024L100.447 99.4889C101.179 98.0054 101.41 95.9824 101.341 93.9169C101.061 89.1348 98.9844 85.5778 96.2523 85.6428L96.1791 85.6505C93.763 85.9045 91.9205 89.5033 92.0392 94.1544C92.1082 96.2198 92.6012 98.0927 93.3485 99.5687L93.5488 100.066L93.9881 100.02C94.8513 99.7808 95.9496 99.6654 96.7703 99.7272C97.7221 99.6272 98.778 99.8123 99.6064 99.9473L100.281 100.024Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.264 108.375C108.214 108.59 106.569 106.32 106.408 103.376C106.385 103.157 106.346 102.791 106.323 102.571L106.408 101.97L112.947 101.505L113.017 102.164C113.04 102.383 113.078 102.749 113.101 102.969C113.475 105.817 112.168 108.175 110.264 108.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1203 108.321C100.17 108.106 101.308 105.543 100.853 102.63C100.83 102.41 100.792 102.044 100.769 101.825L100.561 101.254L94.0675 102.159L94.129 102.745C94.1521 102.964 94.1906 103.33 94.2137 103.55C94.4406 106.413 96.2899 108.514 98.1203 108.321Z",
    fill: "white"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 75.523,
    y: 74.7506,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(-6 75.523 74.7506)",
    stroke: "#E7F1FF",
    strokeWidth: 2
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_11304_9686)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.245 76.7025C210.337 78.776 222.63 69.8441 224.704 56.7524C226.777 43.6608 217.845 31.367 204.754 29.2935C191.662 27.22 179.368 36.1519 177.295 49.2436C175.221 62.3352 184.153 74.629 197.245 76.7025Z",
    fill: "#006FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.421 57.4805L203.283 56.9369C202.63 55.4172 202.504 53.3848 202.681 51.3258C203.212 46.5649 205.471 43.1214 208.196 43.3294L208.342 43.3524C210.741 43.7325 212.393 47.4228 212.031 52.0613C211.854 54.1203 211.264 55.9648 210.44 57.3996L210.214 57.8856L209.705 57.805C208.856 57.5213 207.765 57.3486 206.942 57.3673C205.997 57.2176 204.933 57.3472 204.098 57.4387L203.421 57.4805Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.591 55.2152L197.89 54.7408C198.981 53.4974 199.728 51.6033 200.196 49.5903C201.163 44.8985 200.078 40.9252 197.422 40.281L197.349 40.2695C194.95 39.8894 192.239 42.8887 191.149 47.4121C190.682 49.425 190.673 51.3616 191.013 52.9807L191.078 53.5128L191.514 53.5819C192.409 53.5746 193.5 53.7474 194.277 54.0195C195.222 54.1692 196.194 54.6213 196.959 54.9661L197.591 55.2152Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.073 65.8658C203.037 65.5433 202.036 62.925 202.642 60.0395C202.676 59.8213 202.734 59.4578 202.768 59.2396L203.006 58.6809L209.443 59.9241L209.339 60.5785C209.305 60.7966 209.247 61.1602 209.213 61.3783C208.836 64.2257 206.964 66.1652 205.073 65.8658Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.357 62.669C195.392 62.9914 197.154 60.8107 197.469 57.8792C197.504 57.661 197.561 57.2975 197.596 57.0793L197.543 56.4746L191.037 55.6677L190.945 56.2494C190.91 56.4676 190.852 56.8311 190.818 57.0493C190.296 59.8736 191.539 62.3811 193.357 62.669Z",
    fill: "white"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 180.218,
    y: 24.3949,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(9 180.218 24.3949)",
    stroke: "#E7F1FF",
    strokeWidth: 2
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_11304_9686)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.508 50.869C125.69 49.4835 135.253 37.674 133.868 24.4918C132.482 11.3096 120.673 1.74643 107.491 3.13194C94.3084 4.51745 84.7452 16.3269 86.1308 29.5092C87.5163 42.6914 99.3257 52.2545 112.508 50.869Z",
    fill: "#006FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.498 30.7045L113.225 30.2151C112.2 28.9163 111.553 26.9856 111.191 24.951C110.471 20.215 111.762 16.304 114.448 15.7996L114.595 15.7842C117.011 15.5302 119.561 18.6673 120.412 23.2415C120.774 25.2762 120.681 27.2106 120.257 28.8097L120.165 29.3376L119.652 29.3914C118.758 29.3374 117.66 29.4528 116.87 29.6839C115.918 29.7839 114.924 30.1845 114.142 30.4888L113.498 30.7045Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.281 30.0245L107.447 29.4889C108.179 28.0054 108.41 25.9824 108.341 23.9169C108.061 19.1348 105.984 15.5778 103.252 15.6428L103.179 15.6505C100.763 15.9045 98.9205 19.5033 99.0392 24.1544C99.1082 26.2198 99.6012 28.0927 100.349 29.5687L100.549 30.0658L100.988 30.0196C101.851 29.7808 102.95 29.6654 103.77 29.7272C104.722 29.6272 105.778 29.8123 106.606 29.9473L107.281 30.0245Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.264 38.3748C115.214 38.5903 113.569 36.3204 113.408 33.3763C113.385 33.1567 113.346 32.7906 113.323 32.5709L113.408 31.9698L119.947 31.5046L120.017 32.1635C120.04 32.3832 120.078 32.7493 120.101 32.9689C120.475 35.8167 119.168 38.1748 117.264 38.3748Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.12 38.3211C107.17 38.1056 108.308 35.5433 107.853 32.63C107.83 32.4104 107.792 32.0443 107.769 31.8247L107.561 31.2543L101.067 32.1588L101.129 32.7446C101.152 32.9642 101.191 33.3303 101.214 33.55C101.441 36.4131 103.29 38.5135 105.12 38.3211Z",
    fill: "white"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 82.523,
    y: 4.75063,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(-6 82.523 4.75063)",
    stroke: "#E7F1FF",
    strokeWidth: 2
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_11304_9686)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.09 84.8876C139.075 83.733 147.045 73.8918 145.89 62.9066C144.735 51.9214 134.894 43.9521 123.909 45.1067C112.924 46.2613 104.955 56.1025 106.109 67.0877C107.264 78.0729 117.105 86.0422 128.09 84.8876Z",
    fill: "#006FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.916 68.0828L128.688 67.675C127.834 66.5927 127.295 64.9838 126.993 63.2882C126.393 59.3416 127.469 56.0824 129.708 55.6621L129.83 55.6493C131.843 55.4376 133.969 58.0519 134.678 61.8637C134.979 63.5592 134.902 65.1712 134.548 66.5038L134.471 66.9437L134.044 66.9886C133.299 66.9436 132.384 67.0398 131.726 67.2323C130.932 67.3157 130.104 67.6495 129.452 67.9031L128.916 68.0828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.734 67.5175L123.872 67.0711C124.482 65.8349 124.675 64.1491 124.618 62.4279C124.384 58.4427 122.654 55.4785 120.377 55.5328L120.316 55.5392C118.302 55.7508 116.767 58.7498 116.866 62.6257C116.923 64.3469 117.334 65.9076 117.957 67.1376L118.124 67.5519L118.49 67.5134C119.209 67.3144 120.124 67.2182 120.808 67.2697C121.602 67.1864 122.481 67.3406 123.172 67.4531L123.734 67.5175Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.053 74.4761C130.345 74.6557 128.974 72.764 128.84 70.3107C128.82 70.1276 128.788 69.8226 128.769 69.6395L128.84 69.1386L134.289 68.7509L134.347 69.3C134.366 69.4831 134.398 69.7881 134.418 69.9712C134.729 72.3443 133.64 74.3094 132.053 74.4761Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.934 74.4294C123.642 74.2498 124.59 72.1145 124.211 69.6868C124.192 69.5038 124.16 69.1987 124.141 69.0157L123.967 68.5404L118.556 69.2942L118.608 69.7823C118.627 69.9653 118.659 70.2704 118.678 70.4534C118.867 72.8394 120.408 74.5897 121.934 74.4294Z",
    fill: "white"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 102.92,
    y: 46.3073,
    width: 42,
    height: 42,
    rx: 21,
    transform: "rotate(-6 102.92 46.3073)",
    stroke: "#E7F1FF",
    strokeWidth: 2
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_11304_9686)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.9534 90.9319C93.3797 89.8532 105.011 76.4732 103.932 61.0469C102.853 45.6206 89.4733 33.9896 74.047 35.0683C58.6207 36.147 46.9897 49.527 48.0684 64.9533C49.1471 80.3796 62.5271 92.0106 77.9534 90.9319Z",
    fill: "#006FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9287 67.4635L79.6297 66.8817C78.4877 65.3257 77.8118 63.0483 77.4727 60.6612C76.8262 55.1099 78.4913 50.6024 81.6435 50.1237L81.8149 50.1117C84.6423 49.914 87.4884 53.6756 88.2942 59.0435C88.6333 61.4305 88.4464 63.6822 87.8868 65.5294L87.7573 66.1412L87.1576 66.1831C86.1174 66.0836 84.8322 66.1735 83.9017 66.4108C82.7879 66.4887 81.6123 66.9153 80.6878 67.2382L79.9287 67.4635Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7067 66.4163L72.9218 65.7986C73.8361 64.0987 74.1884 61.7494 74.192 59.3384C74.0596 53.7512 71.7834 49.5193 68.5953 49.4839L68.5096 49.4899C65.6821 49.6876 63.3873 53.8087 63.3364 59.2365C63.3328 61.6475 63.8313 63.8513 64.6425 65.6026L64.8558 66.1904L65.3699 66.1544C66.3861 65.9112 67.6713 65.8213 68.6258 65.9268C69.7396 65.8489 70.9631 66.1077 71.9236 66.2989L72.7067 66.4163Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.008 76.5594C81.609 76.7271 79.7833 74.0135 79.7151 70.5743C79.6971 70.3173 79.6671 69.8889 79.6492 69.6318L79.7726 68.9344L87.4161 68.6582L87.47 69.4294C87.488 69.6864 87.518 70.1148 87.5359 70.3718C87.8553 73.7074 86.2357 76.4036 84.008 76.5594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8508 75.9994C72.2498 75.8316 73.68 72.8903 73.269 69.4751C73.2511 69.2181 73.2211 68.7897 73.2031 68.5326L72.9838 67.8592L65.3763 68.6494L65.4242 69.3349C65.4422 69.5919 65.4721 70.0203 65.4901 70.2774C65.6381 73.6249 67.7088 76.1492 69.8508 75.9994Z",
    fill: "white"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 45.0479,
    y: 36.0937,
    width: 58,
    height: 58,
    rx: 29,
    transform: "rotate(-4 45.0479 36.0937)",
    stroke: "#E7F1FF",
    strokeWidth: 2
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_11304_9686)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.56 63.8933C171.965 65.2411 185.546 53.8453 186.893 38.4402C188.241 23.0351 176.845 9.45415 161.44 8.10638C146.035 6.7586 132.454 18.1543 131.107 33.5595C129.759 48.9646 141.154 62.5455 156.56 63.8933Z",
    fill: "#006FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.183 41.0211L161.978 40.3997C161.094 38.6841 160.783 36.329 160.821 33.9183C161.051 28.3343 163.401 24.1427 166.589 24.163L166.76 24.178C169.584 24.425 171.806 28.5855 171.762 34.0134C171.724 36.4241 171.187 38.6188 170.345 40.3557L170.122 40.9397L169.523 40.8873C168.511 40.6263 167.228 40.514 166.271 40.6028C165.159 40.5055 163.931 40.743 162.968 40.9173L162.183 41.0211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.213 38.8581L155.522 38.2816C156.691 36.7458 157.406 34.4805 157.787 32.0997C158.53 26.5606 156.944 22.0247 153.801 21.491L153.715 21.4836C150.892 21.2365 147.981 24.9478 147.081 30.3009C146.7 32.6816 146.848 34.9362 147.375 36.7929L147.494 37.4068L148.007 37.4517C149.049 37.3705 150.333 37.4827 151.259 37.7362C152.371 37.8335 153.539 38.2806 154.458 38.6196L155.213 38.8581Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.788 50.6433C162.392 50.4337 161.014 47.4679 161.484 44.0604C161.507 43.8037 161.544 43.3759 161.567 43.1192L161.798 42.4496L169.39 43.3726L169.323 44.1426C169.301 44.3993 169.263 44.8271 169.241 45.0838C169.034 48.4283 167.013 50.8379 164.788 50.6433Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.893 47.8765C153.288 48.0861 155.161 45.4048 155.289 41.9673C155.312 41.7106 155.349 41.2828 155.372 41.0261L155.26 40.3266L147.623 39.9171L147.563 40.6016C147.541 40.8583 147.503 41.2861 147.481 41.5428C147.103 44.8722 148.754 47.6894 150.893 47.8765Z",
    fill: "white"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 132.638,
    y: 4.58267,
    width: 58,
    height: 58,
    rx: 29,
    transform: "rotate(5 132.638 4.58267)",
    stroke: "#E7F1FF",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55 90C55 88.8954 55.8954 88 57 88H77.2654C78.2607 88 79.1046 88.7319 79.2453 89.7172L82.7547 114.283C82.8954 115.268 83.7393 116 84.7346 116H185.265C186.261 116 187.105 115.268 187.245 114.283L190.755 89.7172C190.895 88.7319 191.739 88 192.735 88H213C214.105 88 215 88.8954 215 90V116V142C215 143.105 214.105 144 213 144H183H87H57C55.8954 144 55 143.105 55 142V116V90Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 118.5,
    r: 1.5,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M240.5 25.5L254.5 18.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 49.5,
    r: 1.5,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 273.5,
    cy: 51.5,
    r: 1.5,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 7.5,
    r: 1.5,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 237.5,
    cy: 117.5,
    r: 1.5,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 219.5,
    cy: 4.5,
    r: 1.5,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.04,
    width: 216,
    height: 4,
    rx: 2,
    transform: "matrix(1 0 0 -1 27 148)",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M240.5 83L261.5 88.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 29.5L23 21",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 82L15 87",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11304_9686"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 138.521,
    y: 56.832,
    width: 64,
    height: 64,
    rx: 32,
    transform: "rotate(6 138.521 56.832)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_11304_9686"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.6221,
    y: 75.6406,
    width: 48,
    height: 48,
    rx: 24,
    transform: "rotate(-6 76.6221 75.6406)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_11304_9686"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 181.049,
    y: 25.5391,
    width: 48,
    height: 48,
    rx: 24,
    transform: "rotate(9 181.049 25.5391)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_11304_9686"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 83.6221,
    y: 5.64062,
    width: 48,
    height: 48,
    rx: 24,
    transform: "rotate(-6 83.6221 5.64062)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_11304_9686"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 104.019,
    y: 47.1973,
    width: 40,
    height: 40,
    rx: 20,
    transform: "rotate(-6 104.019 47.1973)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_11304_9686"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.1152,
    y: 37.0215,
    width: 56,
    height: 56,
    rx: 28,
    transform: "rotate(-4 46.1152 37.0215)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_11304_9686"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 133.547,
    y: 5.66602,
    width: 56,
    height: 56,
    rx: 28,
    transform: "rotate(5 133.547 5.66602)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectiveSteps);
export default __webpack_public_path__ + "static/media/collective-steps.e2ee9ba8c208fbb3c5c696cb506ea752.svg";
export { ForwardRef as ReactComponent };